<template>
<BootstrapDialog title="课件预览" ref="dialog" :modal-style="{width:1200+'px'}" @afterOpen="afterOpen()" @afterClose="afterClose()">
	<template v-slot:body>
			<div class="modal-body wrapper-lg" style="width:100%;padding:0px">
				<div class="row" style="margin: 0">
					<div class="col-sm-12" style="padding: 10px;">
					<div class="videobox">
							<!-- 播放器 -->
							<div id="video_player" :key="videoPlayerKey" style="position: absolute; left:64px; top:0px; width:calc(100% - 64px); height:100%; overflow: hidden">
								<video  ref="videoDivPlayer" class="video-js vjs-default-skin" autoplay controls preload="auto"
								       style="width: 100%; height: 100%;" :src="videoSrc">
								</video>
							</div>
							<!-- 左侧边栏 -->
					       <div class="videocontrol" tabindex="1" >
								  <ul class="menu-btns" id="y" >
									<li @click.stop="togglActiveMenu('video-menu')" id="video-menu" :class="activeMenu=='video-menu' ? 'menu-actived' : ''">
										<span class="video-menu-ico " :class="activeMenu=='video-menu' ? 'high-light-menu' : ''"></span>
										<p>目录</p>
									</li>
									<li @click.stop="togglActiveMenu('video-files')" id="video-files" :class="activeMenu=='video-files' ? 'menu-actived' : ''">
										<span class="video-files-ico " :class="activeMenu=='video-files' ? 'high-light-menu' : ''"></span>
										<p>附件</p>
									</li>
									<li @click.stop="togglActiveMenu('video-comments')" id="video-comments" :class="activeMenu=='video-comments' ? 'menu-actived' : ''">
										<span class="video-comments-ico " :class="activeMenu=='video-comments' ? 'high-light-menu' : ''"></span>
										<p>评论</p>
									</li>
									<li @click.stop="togglActiveMenu('video-notes')" id="video-notes" :class="activeMenu=='video-notes' ? 'menu-actived' : ''">
										<span class="video-notes-ico " :class="activeMenu=='video-notes' ? 'high-light-menu' : ''"></span>
										<p>笔记</p>
									</li>
								  </ul>
								  <ul class="video-detail" id="x" ref="videoDetail"><!-- 视频列表目录 四个内容 视频 附件 评论 笔记-->
									<li class="video-menu-detail video-menu-li " v-show="activeMenu=='video-menu'"><!--  视频  -->
										  <template v-for="(chapter, indexa) in chapterList">
											  <h3 :key="'chapter_id_' + chapter.id" :chapterid="chapter.id">第{{indexa+1}}章、{{chapter.name}}</h3>
											  <ul class="course-chapter" :key="'lesson_list_' + chapter.id">
												  <template v-for="(lessson, indexb) in chapter.lessons">
													  <li :key="'lesson_id_'+ lessson.id"  :lessonid="lessson.id" :class="lessson.id==activeLessonId ? 'learning' : ''"  @click.stop="toggle(chapter,lessson)">
														  <p>{{indexa+1}}-{{indexb+1}} {{lessson.lesson_name}} <span>({{lessson.curPlayed || 0}}/{{lessson.lesson_minutes}}分钟)</span></p>
														  <i class="course-new" v-if="!lessson.curPlayed || lessson.curPlayed == 0"></i>
														  <i class="course-learning" v-if="lessson.curPlayed> 0 && lessson.curPlayed < lessson.lesson_minutes"></i><a href="javascript:void(0)" v-if="lessson.id==activeLessonId">正在学</a>
														  <i class="course-finish" v-if="lessson.curPlayed>=lessson.lesson_minutes"></i>
													  </li>
												  </template>
											  </ul>
										 </template>
									</li>
									<li class="video-files-detail video-menu-li " v-show="activeMenu=='video-files'"><!--  附件  -->
										<ul class="files-download">
											<a target="_blank" v-for="(item,index) in xxzlList" :key="index" :href="item.xxdz" :download="item">
												<p>{{index+1}}. {{item.zlmc}} <span>({{ item.wjdx }})</span></p>
											</a>
										</ul>
									</li>
									<li class="video-comments-detail video-menu-li " v-show="activeMenu=='video-comments'"><!-- 评论页 -->
										<p class="comment-title">我要评论</p>
										<div class="leave-comment">
											<textarea type="textarea"  class="comment-input" rows="3" cols="20" placeholder="请自觉遵守互联网相关的政策法规，严禁发布色情、暴力、反动的言论。"></textarea>
											<button type="button" class="comment-btn" id="btncomment" >发表评论</button>
										</div>
										<!-- 评论展示 -->
										<div class="comment-area">
										  <p class="comment-show">所有评论  <span>(19)</span></p>
										  <div class="user-comment">
											  <div class="list-item">
												  <div class="user-face"></div>
												  <div class="con">
													<div class="user-name">赵汪汪</div>
													<div class="comment-con">时，长老须菩提在大众中即从座起，偏袒右肩，右膝着地，合掌恭敬而白佛言：“希有！世尊！如来善护念诸菩萨，善付嘱诸菩萨。世尊！善男子、善女人，发阿耨多罗三藐三菩提心，应云何住，云何降伏其心？”佛言：“善哉，善哉。须菩提！如汝所说，如来善护念诸菩萨，善付嘱诸菩萨。汝今谛听！当为汝说：善男子、善女人，发阿耨多罗三藐三菩提心，应如是住，如是降伏其心。”“唯然，世尊！愿乐欲闻。”</div>
													<div class="comment-info">2020-05-02 12:23</div>
												  </div>
											  </div>

											   <div class="list-item">
												  <div class="user-face"></div>
												  <div class="con">
													<div class="user-name">赵汪汪</div>
													<div class="comment-con">时，长老须菩提在大众中即从座起，偏袒右肩，右膝着地，合掌恭敬而白佛言：“希有！世尊！如来善护念诸菩萨，善付嘱诸菩萨。世尊！善男子、善女人，发阿耨多罗三藐三菩提心，应云何住，云何降伏其心？”佛言：“善哉，善哉。须菩提！如汝所说，如来善护念诸菩萨，善付嘱诸菩萨。汝今谛听！当为汝说：善男子、善女人，发阿耨多罗三藐三菩提心，应如是住，如是降伏其心。”“唯然，世尊！愿乐欲闻。”</div>
													<div class="comment-info">2020-05-02 12:23</div>
												  </div>
											  </div>
										  </div>
										</div>
									</li>
									<li class="video-notes-detail video-menu-li " v-show="activeMenu=='video-notes'">  <!--  笔记  -->
										<p class="comment-title title-notes">笔记</p>
										<div class="create-notes">
										  <textarea type="textarea"  class="notes-input" rows="3" cols="20" placeholder=""></textarea>
										  <button type="button" class="notes-btn">添加笔记</button>
										</div>
										<div class="comment-area">
										  <p class="comment-show">我的笔记<span>(19)</span></p>
										  <div class="user-notes">
											  <div class="list-item-notes">
													<div class="notes-edit">
														<span>
														  <svg t="1589341705799" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4803" width="16" height="16"><path d="M98 607.49v132.16h130.42l391.27-396.46-130.42-132.15L98 607.49z m619.5-429.5l-65.21-66.07c-18-18.24-47.2-18.24-65.2 0l-32.6 33.04 130.42 132.15 32.61-33.05c8.65-8.76 13.5-20.65 13.5-33.04-0.01-12.38-4.87-24.27-13.52-33.03zM98 833.1h830v93.44H98V833.1z m0 0" fill="#aaaaaa" p-id="4804"></path></svg></span>
														<p>修改</p>
													</div>
													<div class="notes-time">02:23:32</div>
													<div class="notes-con">这是一条笔记</div>
											  </div>

											  <div class="list-item-notes">
													<div class="notes-edit">
														<span>
														  <svg t="1589341705799" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4803" width="16" height="16"><path d="M98 607.49v132.16h130.42l391.27-396.46-130.42-132.15L98 607.49z m619.5-429.5l-65.21-66.07c-18-18.24-47.2-18.24-65.2 0l-32.6 33.04 130.42 132.15 32.61-33.05c8.65-8.76 13.5-20.65 13.5-33.04-0.01-12.38-4.87-24.27-13.52-33.03zM98 833.1h830v93.44H98V833.1z m0 0" fill="#aaaaaa" p-id="4804"></path></svg></span>
														<p>修改</p>
													</div>
													<div class="notes-time">02:23:32</div>
													<div class="notes-con">这是第二条笔记</div>
											  </div>
										  </div>
										 </div>
									</li>
							</ul>
					   </div>
					</div>
					</div>
				</div>
			</div>
	</template>
	<template v-slot:footer>
			<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>
import $ from 'jquery';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
export default {
	name:'ZypxCourseLearnPreview',
	components:{
	},
	data:function(){
		return {
			xxzlList: [], // 学习资料
			id:'',
			jsxm:'',
			kjdw:'',
			zt:'',
			kjjs:'',
			cjsj:'',
			kcdm:'',
			kcmc:'',
			jgdm:'',
			jgmc:'',
			chapterList:[],
			videoPlayer:null,
			videoSrc:'',
			activeMenu:'',
			activeChapterId:'',
			activeLessonId:'',
			videoPlayerKey:'video_player',
			defaultChapter:{},//默认章
			defaultLesson:{}//默认课时
		}
	},
	mounted:function(){
		this.$nextTick(function() {
			document.addEventListener('click',(e) =>{
				let videoDetail = this.$refs.videoDetail;
				if (videoDetail) {
					if (!videoDetail.contains(e.target)) {
						this.activeMenu = '';
					}
				}
			});
		});
	},
	created:function(){

	},
	methods:{

		reset:function(){
			this.id = '';
			this.jsxm = '';
			this.kjdw = '';
			this.zt = '';
			this.kjjs = '';
			this.cjsj = '';
			this.kcdm = '';
			this.kcmc = '';
			this.jgdm = '';
			this.jgmc = '';
			this.chapterList = [];
			this.videoPlayer = null;
			this.videoSrc = '';
			this.activeMenu = '';
			this.activeChapterId = '';
			this.activeLessonId = '';
			this.defaultChapter = {};
			this.defaultLesson = {};
		},
		async open(params){
			this.id = params.id;
			let res = await this.$http.post('/htgl/inf/zypx/kj/hq',{id:this.id});
			if(res.data){
				this.jsxm = res.data.jsxm;
				this.kjdw = res.data.kjdw;
				this.zt = res.data.zt;
				this.kjjs = res.data.kjjs;
				this.kcdm = res.data.kcdm;
				this.kcmc = res.data.kcmc;
				this.jgdm = res.data.jgdm;
				this.jgmc = res.data.jgmc;
				this.cjsj = res.data.cjsj;
				this.chapterList = res.data.chapters;
				if(this.chapterList && this.chapterList.length>0){
					this.defaultChapter = this.chapterList[0];
					if(this.defaultChapter.lessons && this.defaultChapter.lessons.length> 0){
						this.defaultLesson = this.defaultChapter.lessons[0];
					}
				}
			}
			//销毁上次打开的video组件
			this.videoPlayerKey = 'video_player'+new Date().getTime();
			this.$nextTick(()=>{
				this.$refs.dialog.open();
			});
		},
		afterOpen:function(){
			let optionsa = {
				autoplay: true
			};
			this.videoPlayer = videojs(this.$refs.videoDivPlayer, optionsa, function onPlayerReady() {
				console.log('播放器Ready', this);
			});
			if(this.defaultLesson){
				this.toggle(this.defaultChapter,this.defaultLesson);
			}
		},
		close:function(){
			this.$refs.dialog.close();
		},
		afterClose:function(){
			if(this.videoPlayer){
				this.videoPlayer.pause();
			}
			this.$validator.reset();
			this.reset();
		},
		toggle:function(chapter,lesson){
			this.activeChapterId = chapter.id;
			this.activeLessonId = lesson.id;
			if(this.videoPlayer){
				this.videoPlayer.pause();
				this.videoPlayer.src(lesson.lesson_filepath);
				this.videoPlayer.play();
			}
			if (this.activeChapterId && this.activeLessonId) {
				this.getSesr({
					kjId:this.id,
					zjId:this.activeChapterId,
					id:this.activeLessonId
				});
			}
    },
		getSesr:function(value){
			let query ={
				kjId: value.kjId,
				zjId: value.zjId,
				keshiId: value.id
			}
			this.$http.post('/htgl/inf/zypx/kjxxzl/cx',query).then(res=>{
				this.xxzlList = res.data.list;
				this.xxzlList.forEach(item => {
					let wjdx = this.change(item.wjdx);
					item.wjdx = wjdx
				})
			});
		},
		// 文件大小转化
		change:function (limit){
			let size = "";
			if(limit < 0.1 * 1024){                            //小于0.1KB，则转化成B
				size = limit.toFixed(2) + "B"
			}else if(limit < 0.1 * 1024 * 1024){            //小于0.1MB，则转化成KB
				size = (limit/1024).toFixed(2) + "KB"
			}else if(limit < 0.1 * 1024 * 1024 * 1024){        //小于0.1GB，则转化成MB
				size = (limit/(1024 * 1024)).toFixed(2) + "MB"
			}else{                                            //其他转化成GB
				size = (limit/(1024 * 1024 * 1024)).toFixed(2) + "GB"
			}
			let sizeStr = size + "";                        //转成字符串
			let index = sizeStr.indexOf(".");                    //获取小数点处的索引
			let dou = sizeStr.substr(index + 1 ,2)            //获取小数点后两位的值
			if(dou == "00"){                                //判断后两位是否为00，如果是则删除00
				return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
			}
			return size;
		},
    togglActiveMenu:function(menu){
      if(this.activeMenu == menu){
        this.activeMenu = '';
      }
      else{
        this.activeMenu = menu;
      }
    }
	},
	beforeDestroy() {
	  if(this.videoPlayer){
		  this.videoPlayer.dispose();
	  }
	}

}
</script>

<style>
*{
	margin: 0;
	padding: 0;
}
body{
	font-family: "微软雅黑";
}
li{
	list-style: none;
}

.oh{
	overflow: hidden;
}
.fl{
	float: left;
}
.phone{
	position: absolute;
	left: 121px;
	top: 103px;
}
.app-down{
	position: relative;
	height: 900px;
}
.btn-and-inner,.btn-ios-inner{
	width: 251px;
	height: 85px;
	border-radius: 43px;
	position: absolute;
	left: 3px;
	top: 3px;
	overflow: hidden;
}
.ios{
	margin-top: 50px;
}
.btn-and-inner{
	border: 2px solid #e4574d;
}
.btn-ios-inner{
	border: 2px solid #3db39e;
}
.btn-ios-inner:hover{
	background-color: rgba(61,179,158,.8);
	transition: .3s all ease;
}
.content{
	position: absolute;
	left: 604px;
	top: 170px;
}
.btn-and,.btn-ios{
	width: 261px;
	height: 95px;
	border-radius: 48px;
	border: 1px solid transparent;
	position: relative;
}
.btn-and{
	border-color: rgba(228,87,77,.5);
}
.btn-and-inner:hover{
	background-color: rgba(228,87,77,.8);
	color: #fff;
	transition: .3s all ease;
}
.btn-ios{
	border-color: rgba(61,179,158,.5);

}
.inner-content span{
	display: inline-block;
	float: left;
	width: 29px;
	height: 34px;
}
.inner-content{
	position: absolute;
	left: 36px;
	top: 24px;
}
.ios .inner-content{
	left: 60px;
}
.inner-content p{
	float: left;
	line-height: 34px;
	font-size: 22px;
	margin-left: 12px;
	color: #333;
}
.detail {
	margin-top: 20px;
}
.detail span{
	color: #999;
	font-size: 14px;

}
.wx{
	width: 140px;
	height: 140px;
	border: 1px dotted #e1574c;
}
.wx img{
	width: 126px;
	height: 126px;

	margin-top: 7px;
	margin-left: 7px;
}
.btns{
	margin-top: 90px;
}
.detail .version{
	padding-right: 22px;
	padding-left: 4px;
	border-right: 1px dotted #999;
}
.detail .size{
	padding: 0 22px;
	border-right: 1px dotted #999;
}
.detail .update{
	padding-left: 22px;
}
.sdk-down .container h3{
	font-size: 38px;
	color: #fff;
	font-weight: normal;
	padding-top: 120px;
	margin-bottom: 36px;
}
.sdk-txt{
	margin-left: 95px;
}
.sdk-down .container{
	position: relative;
}
.sdk-down .container p{
	font-size: 18px;
	color: #787e87;
}
.sdk-wx {
	width: 160px;
	height: 160px;
	border-radius: 3px;
	background-color: #fff;
	position: absolute;
	right: 92px;
	top: 99px;
}
.sdk-wx img{
	width: 130px;
	height: 130px;
	margin-top: 14px;
	margin-left: 14px;
}
.group{
	font-size: 18px;
	line-height: 30px;
}
.group .question{
	color: #e1574c;
	font-weight: bold;
}
.group .answer{
	color: #333;

}
.group span{
	display: inline-block;
	line-height: 30px;
}
.group{
	padding: 20px 12px;
}
.qna .container{
	padding: 80px 0;
}
.btn-more{
	height: 60px;
	width: 250px;
	border-radius: 30px;
	border: 1px solid #333;
	line-height: 60px;
	margin: 0 auto;
	text-align: center;
	font-size: 24px;
	margin-top: 50px;
}
.btn-more:hover{
	color: #fff;
	background-color: #333;
	transition: .3s ease all;
	cursor: pointer;
}
.btn{
	cursor: pointer;
	overflow: hidden;
}
.carousel{
	height: 595px;
	background-color: #e4574d;
	width: 100%;
}
.carousel .container{
	position: relative;
}
.tab-btn ul{
	display: block;
	overflow: hidden;
}
.tab-btn{
	height: 64px;
	width: 1200px;
	background-color: #d34337;
	position: absolute;
	left: 0;
	top: 500px;

}
.tab-btn ul li{
	font-size: 24px;
	line-height: 64px;
	cursor: pointer;
	color:#fff;
	display: block;
	width: 20%;
	text-align: center;
	z-index: 999;
	background:transparent;
	background-color: rgba(255,255,255,0);
}
.slider {
  clear:both;
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background-color: #fff !important;
  transition: all 0.5s;
  z-index: 1 !important;
}
.banners{
	width: 1200px;
	height: 353px;
	position: absolute;
	top: 73px;
}
.pics ul li{
	display: block;
	width: 1200px;
	height: 353px;

}
.ban-txt{
	margin-top: 136px;
	margin-left: 30px;
}
.service{
	padding-top: 70px;
	padding-bottom: 20px;
}
.service .container{
	height: 811px;
}
.ser{
	width: 1200px;height: 811px;

}
.wrapper{
	width: 1200px;
	height: 698px;
}
 /*test*/
.ripple {
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(1,1,1,.8);
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
  position: absolute;
  opacity: 1;
  /*z-index: -99;*/
  display: inherit;
}

.rippleEffect {
  -webkit-animation: rippleDrop .4s linear;
  animation: rippleDrop .4s linear;
  position: absolute;
  display: block;
}

@-webkit-keyframes
  rippleDrop {  100% {
   -webkit-transform: scale(2);
   transform: scale(2);
   opacity: 0;
  }
}
@keyframes
  rippleDrop {  100% {
   -webkit-transform: scale(2);
   transform: scale(2);
   opacity: 0;
  }
}
#aicon,#iicon{
	transition: .3s all ease;
}
.btn{
	position: relative;
	overflow: hidden !important;
}
.btn-and-inner{
	overflow: hidden !important;
}

/*新的开始*/
.videobox{
	width: 100%;
	height: 530px;
	background-color: #111;
	overflow: hidden;
	position: relative;
}

.videocontrol{
	position: relative;
	width: 440px;
	height: 530px;
	outline:none;
	overflow: hidden;


}
.menu-btns{
	width: 64px;
	height: 100%;
	background-color: #1d1e1e;
	/*position: absolute;*/
	margin:0 auto;
	text-align: center;
	cursor: pointer;
	border: none;
	float: left;
}
.menu-btns p{
	margin: 0 auto;
	text-align: center;
	color:#aaa;
	font-size: 14px;
	user-select:none;
}
.menu-btns li{
	width: 100%;
	height: 68px;
	padding: 6px 0 6px 0 ;
	transition: .2s background-color;

}
.menu-btns li span{
	display: block;
	width: 36px;
	height: 36px;
	margin: 0 auto;

}
#video-menu span{
	background: url(../../../assets/images/ico-menu.png);
	background-position: 0 0 ;

}
#video-files span{
	background: url(../../../assets/images/ico-files.png);
	background-position: 0 0 ;
}
#video-comments span{
	background: url(../../../assets/images/ico-comments.png);
	background-position: 0 0 ;
}
#video-notes span{
	background: url(../../../assets/images/ico-notes.png);
	background-position: 0 0 ;
}

#video-menu{
	margin-top: 110px;
}

.menu-actived{
	color: #fff;
	background-color: #2c2e2e;

}
.menu-actived2{
	color: #fff;
	background-color: #2c2e2e;
}
.menu-actived span{
	background-position: 0 0;
}
.menu-actived p{
	color: #fff;
}
.video-detail{
	float: left;

}
.video-detail-actived{
	display: block;
}
.video-menu-li {
	height: 530px;
	width: 360px;
	background-color: #2c2e2e;
	width: 360px;
	position: absolute;
	top: 0;
	left: 64px;
	/*color: #fff;*/
	padding: 20px 6px 20px 6px;
	overflow-y: auto;
	overflow-x: hidden;

}
.video-menu-detail h3{
	font-size: 14px;
	color: #fff;
	font-weight: normal;
	margin-left: 24px;
	padding: 10px 0 10px 0;
	cursor: normal;
	user-select:none;
}
.video-menu-detail{
	overflow: auto;
}
	/*改变滚动条样式*/
	.video-menu-li::-webkit-scrollbar              { /* 1 */  width:9px; background-color:#333;}
	::-webkit-scrollbar-button       { /* 2 */ }
	::-webkit-scrollbar-track        { /* 3 */ }
	::-webkit-scrollbar-track-piece  { /* 4 */ }
	.video-menu-li::-webkit-scrollbar-thumb        { /* 5 */ border:solid 2px #333; width:5px;  border-radius:4px; background-color:#fff;}
	.video-menu-li::-webkit-scrollbar-corner       { /* 6 */ background-color:#333;}
	::-webkit-resizer                { /* 7 */ }
	.video-menu-li::-webkit-scrollbar:horizontal   { height:9px;}

.course-learning{
	background-image: url(../../../assets/images/learning.png)
}
.course-finish{
	background-image: url(../../../assets/images/finish.png)
}
.course-new{
	background-image: url(../../../assets/images/new.png)

}
.course-chapter li{
	height: 30px;
	overflow: hidden;
	line-height: 30px;
	border-radius: 4px;
	cursor: pointer;
	color: #aaa;
	transition: .2s all;
}
.course-chapter li:hover{
	background-color: #1d1e1e;
	color: #fff;

}
.course-chapter li p{
	font-size: 14px;
	margin-left: 50px;
	float: left;

}
.course-chapter .learning p{
	color: #00c2fc;
}
.course-chapter li i{
	display: block;
	width: 14px;
	height: 14px;
	float: right;
	margin-top: 8px;
	margin-right: 16px;
	/*background-image: url(../images/learning.png)*/

}
.course-chapter li a{
	display: block;
	user-select:none;
	color: #018db7;
	float: right;
	margin-right:10px;
	font-size: 14px;
	cursor: normal;
	text-decoration: none;

}
.learning{
	background-color: #1d1e1e;
	color:#00c2fc;

}

.menu-actived{
	color: #fff;
	background-color: #2c2e2e;
	transition: .2s all;
}
.menu-actived-span{
	/*background-position: 0px  36px ;*/
	background-color: #f00;

}
.video-files-detail{
	overflow: hidden;
}
.video-files-detail p{

	font-size: 14px;
	line-height: 30px;
	user-select:none;
	cursor: pointer;
	float: left;

}
.files-download li{
	color: #aaa;
	height: 30px;
	border-radius: 4px;
	padding: 0 10px 0 10px;
	transition: .2s all;
}
.files-download  li:hover{
   background-color: #1d1e1e;
   color:#00c2fc;
}

.files-download >li >span{
	float: left;
}

.files-download li >i{
	display: block;
	width: 14px;
	height: 14px;
	background-image: url(../../../assets/images/download.png);
	background-position: 0 0;
	float:right;
	margin-top: 8px;
	transition:.2s all;
}
.files-download {
	padding: 20px;
}
.comment-input{
	width: 250px;
	height: 80px;
	padding: 5px 10px;
	float: left;
	margin-left: 15px;
	color: #333;
	font-size: 12px;
	border-radius: 4px;
	display: inline-block;
	box-sizing: border-box;
	background-color: #f4f5f7;
	border:1px solid #e5e9ef;
	overflow: auto;
	line-height: auto;
	outline: none;
	resize: none;
}
.leave-comment {
	overflow: hidden;
	width: 100%;
	height: 88px;
}

.comment-title{
	font-size: 14px;
	font-weight: bold;
	margin-left: 15px;
	margin-bottom: 6px;
	color: #fff;
}
.comment-btn{
	width: 60px;
	height: 80px;
	float: left;
	margin-left: 10px;
	background-color: #018db7;
	outline:none;
	user-select:none;
	transition: .1s all;
	cursor: pointer;
	vertical-align: top;
	color: #fff;
	/*margin-top: 6px;
	margin-left: 15px;*/
	margin-right: 10px;
	border:1px solid #018db7;
	border-radius: 4px;
}
.comment-btn:hover{
	background-color: #089bc7;
}
.comment-area{
	width: 100%;
	margin:10px 15px 0 15px;
}
.comment-show{
	font-size: 14px;
	padding-bottom: 10px;
	color: #fff;
	font-weight: normal;
	width:332px;
	border-bottom: 1px solid #666;
}
.btn-close{
	position: absolute;
	top: 8px;
	right: 8px;
	color: #aaa;
	font-size: 12px;
	user-select:none;
	cursor: pointer;
}
.list-item{
	overflow: hidden;
	width: 320px;
	margin:20px 0 0 0 ;
}
.user-comment{
	margin: 10px 0 10px 0;
}
.con{
	float: left;
	margin-left: 10px;
	width: 270px;
	padding: 0 0 16px 0;
	border-bottom: 1px solid #aaa;
}
.user-face{
	width: 40px;
	height: 40px;
	background-image: url(../../../assets/images/head01.jpg);
	float: left;
}
.user-name{
	color: #aaa;
	font-size: 12px;

}
.comment-con{
	color: #fff;
	font-size: 12px;
	margin-top: 6px;
}
.comment-info{
	color: #aaa;
	font-size: 12px;
}
.video-menu-li>i{
	display: block;
	width: 32px;
	height: 12px;
	font-size: 14px;
	position: absolute;
	color: #aaa;
	right: 6px;
	top: 6px;
	user-select:none;
	cursor: pointer;
	font-weight: normal;
	font-style: normal;
	transition: .1s all;
}
.video-menu-li>i:hover{
	color: #fff;
}
.title-notes span{
	display: inline-block;

}
.title-notes p{
	line-height: 40px;
}

.icon{
	/*margin-top: 4px;*/
}
#userCamera{
	width: 100px;
	height: 100px;
	border-radius: 4px;
	border:1px solid #aaa;
	background-color: #222;
	position: absolute;
	top:10px;
	right: 10px;
	z-index: 9;
}
.user-notes{
	width: 332px;
	font-size: 14px;
	line-height: 18px;
	margin:10px 0 10px 0;
}
.notes-time{
	color: #aaa;

}
.notes-con{
	color: #fff;
	margin-top: 10px;
	margin-bottom: 10px;
}
.list-item-notes{
	border-bottom: 1px solid #aaa;
	padding: 8px 0 8px 0;
	position: relative;
}
.notes-input{
	width: 320px;
	height: 120px;
	padding: 5px 10px;
	/*float: left;*/
	margin-left: 15px;
	color: #333;
	font-size: 12px;
	border-radius: 4px;
	display: inline-block;
	box-sizing: border-box;
	background-color: #f4f5f7;
	border:1px solid #e5e9ef;
	overflow: auto;
	line-height: auto;
	outline: none;
	resize: none;
}
.notes-btn{

	width: 120px;
	height: 40px;
	/*float: left;*/
	margin-left: 15px;
	margin-top: 8px;
	background-color: #018db7;
	outline:none;
	user-select:none;
	transition: .1s all;
	cursor: pointer;
	vertical-align: top;
	color: #fff;
	border:1px solid #018db7;
	border-radius: 4px;
	transform-style: .2s all;

}
.create-notes{
	width: 100%;
	height: 200px;
	overflow: hidden;

}
.notes-btn:hover{
	background-color: #089bc7;
}
.notes-edit{
	position: absolute;
	right: 6px;
	top: 10px;
	overflow: hidden;
}
.notes-edit p{
	display: inline-block;
	float: left;
	color: #aaa;
	font-size: 12px;
	cursor: pointer;
	user-select:none;
}
.notes-edit span{
	width: 16px;
	height: 16px;
	float: left;
}
.high-light-menu {
	background-position: 0px 36px!important;
}
.video-js .vjs-big-play-button {
		top: calc(50% - 30px)!important;
		left:calc(50% - 40px)!important;
}
.vjs-error .vjs-error-display .vjs-modal-dialog-content {
	z-index: -90;
}
</style>
